import getValidPeriodKey from 'utils/pivot/plan/period/getValidPeriodKey'

function getAndValidatePeriod(
  plan: Plan,
  period?: number | string
): Durations | undefined {
  const constValidPeriodKey = getValidPeriodKey(plan, period)
  return plan.durations[constValidPeriodKey]
}

export default getAndValidatePeriod
